import { ToolAppData } from './ToolAppData'
import { CommandType } from '@/helpers/EnumHelpers'

export class ToolComData extends ToolAppData {
  public shortName: string
  public toolTipText: string
  public availabilityClassName: string
  public type: CommandType
  public largeIconFileName: string
  public smallIconFileName: string

  constructor(
    pName: string,
    pAssemblyName: string,
    pClassName: string,
    pId: string,
    pShortName: string,
    pToolTipText: string,
    pAvailabilityClassName: string,
    pType: CommandType,
    pLargeIconFileName: string,
    pSmallIconFileName: string
  ) {
    super(pName, pAssemblyName, pClassName, pId)

    this.shortName = pShortName
    this.toolTipText = pToolTipText
    this.availabilityClassName = pAvailabilityClassName
    this.type = pType
    this.largeIconFileName = pLargeIconFileName
    this.smallIconFileName = pSmallIconFileName
  }
}
